import { onlineClassesPath } from "@outschool/routes";

import { CategoryNavLink } from "./navbarCategories";

/**
 * Gets the URL for a category, using the custom path if available or generating one from the slug
 */
export function getCategoryUrl(category: CategoryNavLink): string {
  return category.path || onlineClassesPath(category.slug, category.basePath);
}

/**
 * Checks if a category has subcategories
 */
export function hasSubcategories(category: CategoryNavLink): boolean {
  return Boolean(
    category.getSubcategories && category.getSubcategories?.().length > 0,
  );
}
